export default {
	'': 'App',
	'#config': 'Config',
	'#configReconnect' : 'Config',
	'#login': 'Login',
	'#serve': 'Serve'
}